var React = require('react');

function CrossInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M0.295925 0.295896C-0.0945992 0.68642 -0.100571 1.32556 0.289954 1.71608L4.57438 6.00051L0.289925 10.285C-0.100599 10.6755 -0.0946285 11.3146 0.295896 11.7051C0.68642 12.0957 1.32556 12.1016 1.71608 11.7111L6.00054 7.42666L10.285 11.7111C10.6755 12.1016 11.3146 12.0957 11.7052 11.7051C12.0957 11.3146 12.1017 10.6755 11.7111 10.285L7.42669 6.00051L11.7111 1.71609C12.1016 1.32557 12.0957 0.686431 11.7051 0.295907C11.3146 -0.0946171 10.6755 -0.100589 10.285 0.289936L6.00054 4.57435L1.71611 0.289925C1.32559 -0.100599 0.686449 -0.0946286 0.295925 0.295896Z","fill":"#151414"}));
}

CrossInline.defaultProps = {"width":"12","height":"12","viewBox":"0 0 12 12","fill":"none"};

module.exports = CrossInline;

CrossInline.default = CrossInline;
